import { createSelector } from 'reselect';

const selectUserList = (state) => state.getIn(['me', 'list', 'data'], []);

const makeSelectUserListById = (userId) =>
  createSelector(selectUserList, (state) => state.find(({ id }) => id === userId));

export { makeSelectUserListById };
